import Button, { type ButtonProps } from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import useTranslate from 'hooks/useTranslate';

interface SubmitButtonProps extends ButtonProps {
    loading?: boolean;
}

export const SubmitButton = ({
    children,
    loading = false,
    disabled = false,
    ...rest
}: SubmitButtonProps) => {
    const { translate } = useTranslate();

    return (
        <Button
            variant="contained"
            type="submit"
            size={rest.size}
            {...rest}
            disabled={loading || disabled}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, textTransform: 'initial' }}>
                {loading && <CircularProgress size={18} color="inherit" />}
                {typeof children === 'string' ? translate(children) : children}
            </Box>
        </Button>
    );
};

export default SubmitButton;
